"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var useAcdcOptionProps_1 = __importDefault(require("./useAcdcOptionProps"));
var renderPropType_1 = __importDefault(require("./utils/renderPropType"));
var wrapEvent_1 = __importDefault(require("./utils/wrapEvent"));
var AcdcOption = function (_a) {
    var _b;
    var index = _a.index, value = _a.value, disabled = _a.disabled, onMouseEnterProp = _a.onMouseEnter, onMouseLeaveProp = _a.onMouseLeave, onClickProp = _a.onClick, _c = _a.tag, tag = _c === void 0 ? 'li' : _c, _d = _a.keyboardHighlightedClassName, keyboardHighlightedClassName = _d === void 0 ? '' : _d, _e = _a.mouseHighlightedClassName, mouseHighlightedClassName = _e === void 0 ? '' : _e, _f = _a.selectedClassName, selectedClassName = _f === void 0 ? '' : _f, _g = _a.highlightedClassName, highlightedClassName = _g === void 0 ? '' : _g, className = _a.className, _h = _a.children, children = _h === void 0 ? react_1.default.createElement(react_1.default.Fragment, null, value) : _h, props = __rest(_a, ["index", "value", "disabled", "onMouseEnter", "onMouseLeave", "onClick", "tag", "keyboardHighlightedClassName", "mouseHighlightedClassName", "selectedClassName", "highlightedClassName", "className", "children"]);
    var optionProps = useAcdcOptionProps_1.default(index, value, { disabled: disabled });
    var _j = __read(optionProps, 2), _k = _j[0], _l = _j[1], isSelected = _l.isSelected, isHighlighted = _l.isHighlighted, isMouseHighlighted = _l.isMouseHighlighted, isKeyboardHighlighted = _l.isKeyboardHighlighted, onMouseEnter = _k.onMouseEnter, onMouseLeave = _k.onMouseLeave, onClick = _k.onClick, restOptionProps = __rest(_k, ["onMouseEnter", "onMouseLeave", "onClick"]);
    var handleMouseEnter = wrapEvent_1.default(onMouseEnterProp, onMouseEnter);
    var handleMouseLeave = wrapEvent_1.default(onMouseLeaveProp, onMouseLeave);
    var handleClick = wrapEvent_1.default(onClickProp, onClick);
    if (typeof children === 'function') {
        return children.apply(void 0, __spread(optionProps));
    }
    var Tag = tag;
    var combinedProps = __assign(__assign({ onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleClick, className: classnames_1.default(className, (_b = {},
            _b[selectedClassName] = isSelected,
            _b[highlightedClassName] = isHighlighted,
            _b[mouseHighlightedClassName] = isMouseHighlighted,
            _b[keyboardHighlightedClassName] = isKeyboardHighlighted,
            _b)), children: children }, restOptionProps), props);
    return react_1.default.createElement(Tag, __assign({}, combinedProps));
};
if (process.env.NODE_ENV !== 'production') {
    AcdcOption.propTypes = {
        index: prop_types_1.default.number.isRequired,
        value: prop_types_1.default.string,
        children: renderPropType_1.default(['index', 'value']),
    };
}
exports.default = react_1.memo(AcdcOption);
